<template>
  <div class="Index">
    <IndexTop></IndexTop>
    <div class="main">
      <LeftMenu ref="LeftMenu"></LeftMenu>
      <div class="main_right">
        <PaiChangCurrent ref="GameListAll" v-if="menu_clicked == 1"></PaiChangCurrent>
        <PaiChangCurrent2 ref="GameListAll" v-if="menu_clicked == 2"></PaiChangCurrent2>
        <PaiChangHistory ref="GameListPlaying" v-if="menu_clicked == 3"></PaiChangHistory>
        <LobbyGames ref="LobbyGames" v-if="menu_clicked == 4"></LobbyGames>
        <Membership ref="Membership" v-if="menu_clicked == 5"></Membership>
        <Statistics ref="Statistics" v-if="menu_clicked == 6"></Statistics>
        <ProblemOstentation ref="ProblemOstentation" v-if="menu_clicked == 7"></ProblemOstentation>
        <GameVersion ref="GameVersion" v-if="menu_clicked == 8"></GameVersion>
        <ShopWaiter ref="ShopWaiter" v-if="menu_clicked == 9"></ShopWaiter>
        <PaiChangWaiting ref="PaiChangWaiting" v-if="menu_clicked == 10"></PaiChangWaiting>
      </div>
    </div>
  </div>
</template>

<script>
import IndexTop from './IndexTop'
import LeftMenu from './LeftMenu'
import PaiChangCurrent from './PaiChangCurrent'
import PaiChangCurrent2 from './PaiChangCurrent2'
import PaiChangHistory from './PaiChangHistory'
import LobbyGames from './LobbyGames'
import Membership from './Membership'
import Statistics from './Statistics'
import ProblemOstentation from './ProblemOstentation'
import GameVersion from './GameVersion'
import ShopWaiter from './ShopWaiter'
import PaiChangWaiting from './PaiChangWaiting'

export default {
  components: {
    IndexTop,
    LeftMenu,
    PaiChangCurrent,
    PaiChangCurrent2,
    PaiChangHistory,
    LobbyGames,
    Membership,
    Statistics,
    ProblemOstentation,
    GameVersion,
    ShopWaiter,
    PaiChangWaiting
  },
  data () {
    return {
      menu_clicked: 1
    }
  },
  methods: {
    get_menu_clicked () {
      return this.menu_clicked
    },
    set_menu_clicked (id) {
      this.menu_clicked = id
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
div.index {
  display: flex;
  width: 100vw;
  height: 100vh;
  flex-direction: column;
}
.main {
  flex: 1;
  display: flex;
  height: calc(100vh - 80px);
  justify-content: space-between;
}
.Index{
  height: 100vh;
}
.main_right{
  padding:0 20px 20px 20px;
  width: 100%;
  height: calc(100vh - 100px);
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue